package fyi.moko.hotpl.ui.detail

import fyi.moko.hotpl.domain.model.PlaceRichness
import fyi.moko.hotpl.domain.model.RichnessSignal

/** One line of the sheet behind the richness badge: what the axis is, and whether it is filled. */
internal data class RichnessRow(
    val signal: RichnessSignal,
    val label: String,
    /** Shown under the label only while the axis is empty — what tapping the row will do. */
    val hint: String,
    val filled: Boolean,
)

/**
 * The four axes in a fixed order, each marked filled or not.
 *
 * ── 왜 배지는 그대로 두고 목록을 따로 여는가 (0-25) ──────────────────────────────
 * 배지의 점은 일부러 축 라벨이 없다 — 채우라고 재촉하는 체크리스트가 아니라 질감 신호다.
 * 그런데 리뷰어는 정확히 "뭐가 비었나"를 물었다. 둘을 다 지키는 길은 배지를 **탭했을 때만**
 * 답하는 것이다. 여기 순서는 점의 순서(채운 개수만큼 왼쪽부터)와 무관하게 고정이다.
 */
internal fun richnessChecklist(richness: PlaceRichness): List<RichnessRow> =
    RichnessSignal.entries.map { signal ->
        RichnessRow(
            signal = signal,
            label = when (signal) {
                RichnessSignal.VISIT -> "A visit"
                RichnessSignal.PHOTO -> "A photo"
                RichnessSignal.TAGS -> "A tag"
                RichnessSignal.STORY -> "A note or a feeling"
            },
            hint = when (signal) {
                RichnessSignal.VISIT -> "Log a visit"
                RichnessSignal.PHOTO -> "Add one in Edit"
                RichnessSignal.TAGS -> "Add one in Edit"
                RichnessSignal.STORY -> "Leave one with a visit"
            },
            filled = signal in richness,
        )
    }
